import $ from 'jquery';

const $shareButton = $('.share-button');
let lastCopied = false;

$(function () {
    if ($shareButton.length > 0) {
        window.addEventListener('copy', () => {
            lastCopied = window.getSelection().toString();
            updateButtons();
        });
        $shareButton.each(function () {
            share($(this));
        });
    }
});

const share = (element) => {
    const lang = element.closest('.share').data('lang');
    const title = element.data('title');
    const url = element.data('url');

    if (!navigator.share) {
        if (navigator.clipboard) {
            if (lang === 'sk') {
                element.attr('title', 'Kopírovať odkaz stránky');
            } else {
                element.attr('title', 'Copy site link');
            }
        } else {
            element.css('display', 'none');
        }
    }

    element.on('click', function () {
        if (navigator.share) {
            navigator
                .share({
                    title: title,
                    url: url,
                })
                .catch(console.error);
        } else if (navigator.clipboard) {
            navigator.clipboard
                .writeText(url)
                .then(() => {
                    lastCopied = url;

                    const event = new CustomEvent('alert', {
                        detail: {
                            type: 'success',
                            msg: 'Odkaz stránky bol skopírovaný do schránky.',
                            msgEn: 'The page link has been copied to the clipboard.',
                        },
                    });
                    document.dispatchEvent(event);
                })
                .catch(console.error);
            element.addClass('active');
        }
    });
};

const updateButtons = () => {
    const $activeButton = $('.share-button.active');

    if ($activeButton !== undefined) {
        if (lastCopied !== $activeButton.data('url')) {
            $activeButton.removeClass('active');
        }
    }
};
